import { Box, Typography } from "@mui/material";
import { CommonStyle } from "Components";
import CstmIconBtn from "Components/CstmIconBtn";
import Loader from "Components/Loader";
import ImgPath from "Constant/Imgs";
import { PatientInitialStateType } from "DataTypes/Redux";
import { LoggedTimeType } from "DataTypes/Services/Patient.type";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CarePlanApi from "Service/CarePlan.api";

interface ViewLogPdfProps {
  row: LoggedTimeType
}

const ViewLogPdf: FC<ViewLogPdfProps> = ({ row }) => {
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    row && handleGetPdf(true);
    return () => {
      pdfUrl && URL.revokeObjectURL(pdfUrl);
    };
  }, [row])

  const handleGetPdf: (isViewOnly: boolean) => void = async (isViewOnly) => {
    isViewOnly && setLoading(true);
    const res = await CarePlanApi.AddonTimePDFDownload({
      id1: row.id,
    });
    const binaryResponse = res.data;
    const blob = new Blob([binaryResponse], {
      type: "application/pdf",
    });
    const newUrl = `${window.URL.createObjectURL(blob)}#toolbar=0&navpanes=0`;
    if (isViewOnly) {
      setPdfUrl(newUrl);
      setLoading(false);
    } else {
      const link = document.createElement("a");
      link.href = newUrl;
      link.download = `${patientInfo.name}_Add_On_Time_Log.pdf`;
      link.click();
      URL.revokeObjectURL(newUrl);
    }
  };

  if (loading) return <Loader />

  return (
    <Box height="100%">
      <Box
        height="10%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography sx={{ ...CommonStyle.sxHeading }}>
          {patientInfo.name}
        </Typography>
        <CstmIconBtn
          icon={<ImgPath.DownloadIcon />}
          onClick={() => handleGetPdf(false)}
          title="Download"
        />
      </Box>
      <Box height="90%">
        <object width={"100%"} height={"100%"} data={pdfUrl} />
      </Box>
    </Box>
  );
};

export default ViewLogPdf;